
import { Component, OnInit } from '@angular/core';
import { lang_help } from 'app/idiomas/i18n/ayuda/ayuda.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { fuseAnimations } from '@fuse/animations';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import * as colabInter from 'app/main/pagina/encuestador-n35/colaboradores35/colaboradores35.interface';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-normatips',
  templateUrl: './normatips.component.html',
  styleUrls: ['./normatips.component.scss']
})
export class NormatipsComponent implements OnInit {

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
  ) {
    lang_help.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
  }

  videosTips1 = [

    {
      titulo  : "Niveles de usuario",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/2. Niveles de usuario.mp4',
    },{
      titulo  : "Carga de logo",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/3. Carga de logo.mp4',
    },{
      titulo  : "Requerimientos técnicos",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/4 Requerimientos tecnicos.mp4',
    }

  ]
  videosTips2 = [
    {
      titulo  : "Llenado de plantilla",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/5. Llenado de plantilla.mp4',
    },{
      titulo  : "Carga de plantilla",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/6. Carga de plantilla.mp4',
    },{
      titulo  : "Programar encuesta",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/7. Programar encuesta LISTO.mp4',
    }
  ]
  videosTips3 = [
   {
      titulo  : "Pruebas del cuestionario",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/8. Pruebas del cuestionario.mp4',
    },{
      titulo  : "Lanzamiento y conteos",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/9. Lanzamiento y conteos.mp4',
    },{
      titulo  : "Cierre y resultados",
      descripcion  : "",
      liga: DATOS_API.urlAssets + 'video/normaTips/10. Cierre y resultados.mp4',
    }
  ]


}
